// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class FileService {

//   constructor() { }
// }

import { Injectable } from '@angular/core';
import { FileHandle } from './drag-drop.directive';
import { DialogType } from './medi-dialog/medi-dialog.component';
import { OroService } from './oroservice';

const MaxSize: number = 10000000;

@Injectable({
  providedIn: 'root'
})
export class FileService {
    public files: File[] = [];

    public isFormatInavlid = false;
    public isFileTooBig = false;

    constructor(public oroservice: OroService) {
        this.files = [];
    }

    validateUploadFileSelectedOnly(file: File) {
        console.log(file.name.slice(-3).toUpperCase());
        if (file.name.slice(-3).toUpperCase() == "PDF"
            || file.name.slice(-3).toUpperCase() == "JPG"
            || file.name.slice(-4).toUpperCase() == "JPEG") {
            return true;
        }
        else {
            this.isFormatInavlid = true;
            return false;
        }
    }

    getfiles() {
        if (this.files.length == 0) return new FormData();
        let formData = new FormData();
        let index = 0;
        this.files.forEach(file => {
            formData.append('fileItem-' + index++, file, file.name);
            console.log(file.name + index);
        });
        return formData;
    }

    removeFile(file: File) {
        this.files = this.files.filter(obj => obj !== file);
        this.checkFilesSize();
    }

    removeAllFiles() {
        this.files = [];
        this.isFileTooBig = false;
    }

    tryAddingFile(file: File) {
        var index = this.files.findIndex(o => o.name == file.name && o.size == file.size);
        if (index >= 0) return;
        if (this.validateUploadFileSelectedOnly(file)) {
            this.files.push(file);
        }
    }

    filesDropped(files: FileHandle[]): void {
        this.addFiles(files, null);
      }

    handleMultiFileInput(files: FileList) {
        this.addFiles(null, files);
    }

    addFiles(files: FileHandle[], filelist: FileList)
    {
        this.isFormatInavlid = false;

        if (files && files.length > 0)
        {
            files.forEach(o => this.tryAddingFile(o.file));
        }
        else if (filelist)
        {
            Array.from(filelist).forEach(o => this.tryAddingFile(o));
        }

        if (this.isFormatInavlid)
        {
            this.oroservice.openDialog("500px", "Achtung", "ErrorFileFormat", "OK", DialogType.Warning);
        }

        this.checkFilesSize();
    }

    public checkFilesSize() {
        let sizeTotal: number = this.files.map(a => a.size).reduce(function(a, b) {
            return a + b;
        });

        this.isFileTooBig = sizeTotal > MaxSize;
    }

    public getFileInfo(file: File) : string {
        return file.name + " (" + (file.size / 1000000).toFixed(3) + ("MB)");
    }
}
